/**
 * Route for `permission-scopes-link-payout-team-invoice-automat`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { PermissionScopesLinkPayoutTeamInvoiceAutomatPage } from "../features/permission-scopes-link-payout-team-invoice-automat/PermissionScopesLinkPayoutTeamInvoiceAutomatPage";

export const permissionScopesLinkPayoutTeamInvoiceAutomatRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/permission-scopes-link-payout-team-invoice-automat",
	component: PermissionScopesLinkPayoutTeamInvoiceAutomatPage,
});

export default permissionScopesLinkPayoutTeamInvoiceAutomatRoute;
